export default __webpack_public_path__ + "static/media/sara02.35ef74d1.png";